<template>
  <div class="header">
    <div class="name">
      <!-- <back-page /> -->
      <h3>{{ isPreview ? '我的报名表' : '我的简历' }}</h3>
      <p>
        <el-popover
          v-if="deliverJob && deliverJob.resumeStatus == -1 && deliverJob.reason"
          placement="bottom-start"
          title="补充说明"
          width="200"
          trigger="hover"
          :content="deliverJob.reason"
        >
          <template #reference>
            <el-button type="danger" plain>退回补充材料</el-button>
          </template>
        </el-popover>
      </p>

      <!-- <el-button v-if="isPreview && resume.id" type="primary" plain size="small" @click.stop="router.push('/preview')">预览简历</el-button> -->
      <el-button v-if="isPreview && deliverJob" type="primary" plain size="small" @click.stop="printFunc">下载打印</el-button>
      <slot v-if="!isPreview && resume.id && activityId && canEdit">
        <el-button v-if="deliverJob" type="primary" size="small" @click.stop="deliverFunc">重新提交</el-button>
        <el-button v-else type="primary" size="small" @click.stop="router.push('/job?activityId=' + activityId)">去投递</el-button>
      </slot>
    </div>
  </div>
  <div class="resume">
    <div v-if="isPreview">
      <template v-if="deliverJob">
        <h2 style="text-align: center">{{ title }}</h2>
        <br />
        <Preview v-model="resume" :isSpecific="isSpecific" id="printContent" :job="deliverJob" />
      </template>
      <el-empty v-else :image-size="140" description="未报名成功"> </el-empty>
    </div>
    <div class="content" v-else>
      <div class="steps" v-if="!isPreview">
        <div v-for="(item, index) in steps" :key="item.value" class="steps_item" :class="{ active: item.status === 'success' }">
          <div v-if="index !== 0" class="line" />
          <div>
            <success-filled v-if="item.status === 'success'" />
            <span class="num" v-else>{{ index + 1 }}</span
            >{{ item.name }}
          </div>
        </div>
      </div>
      <div class="form_content">
        <!-- 基本信息 -->
        <Basic v-model="resume" :canEdit="canEdit" :isSpecific="isSpecific" @callback="stepCallback" />
        <!-- 家庭成员 -->
        <HomeList v-model="resume" :canEdit="canEdit" :isSpecific="isSpecific" @callback="stepCallback" />
        <!-- 教育经历 -->
        <Education v-model="resume" :canEdit="canEdit" :isSpecific="isSpecific" @callback="stepCallback" />
        <!-- 工作经历 -->
        <Work v-model="resume" :canEdit="canEdit" :isSpecific="isSpecific" @callback="stepCallback" />
        <!-- 业务获奖 -->
        <Award v-if="isSpecific" v-model="resume" :canEdit="canEdit" @callback="stepCallback" />
        <!-- 主要业绩 -->
        <!-- <Achievement v-if="isSpecific" v-model="resume" :canEdit="canEdit" @callback="stepCallback" /> -->
        <!-- 论文论著 -->
        <Publication v-if="isSpecific" v-model="resume" :canEdit="canEdit" @callback="stepCallback" />
        <!-- Honor / Desert 显示二选一 -->
        <Honor v-if="isSpecific" v-model="resume" :canEdit="canEdit" @callback="stepCallback" />
        <Desert v-else v-model="resume" :canEdit="canEdit" @callback="stepCallback" />
        <!-- 其他情况说明 -->
        <Remark v-if="!isSpecific" v-model="resume" :canEdit="canEdit" @callback="stepCallback" />
        <!-- 附件 -->
        <Other v-model="resume" :canEdit="canEdit" :isSpecific="isSpecific" @callback="stepCallback" />
      </div>
    </div>
  </div>
</template>

<script>
import { onActivated, reactive, toRefs, watch, computed } from 'vue';
import { ElMessage } from 'element-plus';
import { SuccessFilled } from '@element-plus/icons';
import printJS from 'print-js';
import ApplicantApi from '../../service/api/applicant';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import BackPage from '../../components/BackPage.vue';
import Preview from './Preview.vue';
import Basic from './Basic.vue';
import HomeList from './HomeList.vue';
import Education from './Education.vue';
import Work from './Work.vue';
import Award from './Award.vue';
import Publication from './Publication.vue';
import Honor from './Honor.vue';
import Desert from './Desert.vue';
import Remark from './Remark.vue';
import Other from './Other.vue';
// import Achievement from './Achievement.vue';

export default {
  name: 'Resume',
  components: {
    SuccessFilled,
    BackPage,
    Preview,
    Basic,
    HomeList,
    Education,
    Work,
    Award,
    Publication,
    Honor,
    Desert,
    Remark,
    Other,
    // Achievement,
  },
  setup() {
    const route = useRoute();
    const state = reactive({
      resume: {
        cvHomeList: [],
        cvEducationalList: [],
        cvRecordList: [],
        cvDesertList: [],
      },
      deliverJob: null,
      isPreview: route.path.includes('preview'),
    });

    const stepCallback = () => {
      getResume();
    };

    const store = useStore();
    const isSpecific = computed(() => store.state.isSpecific); //是否是专项招聘
    const steps = computed(() => {
      if (isSpecific.value) {
        return [
          { name: '基本信息', value: 'basic', status: state.resume?.id ? 'success' : 'wait' },
          { name: '家庭主要成员', value: 'home', status: state.resume?.cvHomeList?.length ? 'success' : 'wait' },
          { name: '教育经历', value: 'educational', status: state.resume?.cvEducationalList?.length ? 'success' : 'wait' },
          { name: '工作经历', value: 'record', status: state.resume?.cvRecordList?.length ? 'success' : 'wait' },
          { name: '业务获奖情况', value: 'award', status: state.resume?.cvAwardList?.length ? 'success' : 'wait' },
          // { name: '主要业绩(成果)', value: 'achievement', status: state.resume?.cvAchievementList?.length ? 'success' : 'wait' },
          { name: '论文论著情况', value: 'publication', status: state.resume?.cvPublicationList?.length ? 'success' : 'wait' },
          { name: '所获荣誉和表彰奖励', value: 'honor', status: state.resume?.cvHonorList?.length ? 'success' : 'wait' },
          { name: '附件', value: 'other', status: state.resume?.fileUrl ? 'success' : 'wait' },
        ];
      }
      return [
        { name: '基本信息', value: 'basic', status: state.resume?.id ? 'success' : 'wait' },
        { name: '家庭主要成员', value: 'home', status: state.resume?.cvHomeList?.length ? 'success' : 'wait' },
        { name: '教育经历', value: 'educational', status: state.resume?.cvEducationalList?.length ? 'success' : 'wait' },
        { name: '工作 | 实习经历', value: 'record', status: state.resume?.cvRecordList?.length ? 'success' : 'wait' },
        { name: '奖惩信息', value: 'desert', status: state.resume?.cvDesertList?.length ? 'success' : 'wait' },
        { name: '其他说明', value: 'remark', status: state.resume?.remark ? 'success' : 'wait' },
        { name: '附件', value: 'other', status: state.resume?.fileUrl ? 'success' : 'wait' },
      ];
    });

    let timer = null;
    const getResume = async () => {
      if (timer) return;
      timer = setTimeout(async () => {
        clearTimeout(timer);
        timer = null;
        const userInfo = store.state.userInfo;
        if (userInfo && userInfo.userId) {
          const respond = await ApplicantApi.getResume({
            userId: userInfo.userId,
          });
          state.resume = respond[respond.length - 1] || {};
        }
      }, 100);
    };
    watch(() => store.state.userInfo, getResume);
    onActivated(() => {
      getResume();
      getDeliverList();
    });

    let timer2 = null;
    const getDeliverList = () => {
      if (timer2) return;
      timer2 = setTimeout(async () => {
        clearTimeout(timer2);
        timer2 = null;
        const userInfo = store.state.userInfo;
        if (userInfo && userInfo.basicId) {
          try {
            const respond = await ApplicantApi.getMyDeliver(userInfo.basicId);
            state.deliverJob = respond[0] || null;
          } catch {
            state.deliverJob = null;
          }
        }
      }, 100);
    };
    const deliverFunc = async (item) => {
      const { userInfo } = store.state;
      if (!userInfo.basicId) {
        return ElMessage.warning('先填写简历再投递');
      }
      try {
        await ApplicantApi.resendResume({
          activityId: +activityId.value,
          // jobId: +state.deliverJob.jobId,
          userId: userInfo.userId,
          basicId: userInfo.basicId,
        });
        ElMessage.success('投递成功');
        getResume();
        getDeliverList();
      } catch (e) {
        console.error('投递失败', e);
      }
    };

    const title = computed(() => `${store.state.currentBatch?.activityName}报名表`);
    const printFunc = () => {
      if (/Version\/([\d.]+).*Safari/.test(navigator.userAgent)) {
        return ElMessage.warning('建议使用Google/Edge浏览器下载打印');
      }
      printJS({
        printable: 'printContent',
        type: 'html',
        font_size: '',
        documentTitle: 'zhaopin.hubeidaily.net',
        ignoreElements: ['ignoreTimePrint'],
        // header: `${state.resume.name}的简历`,
        header: title.value,
        headerStyle: 'text-align:center;',
        maxWidth: 1000,
        targetStyles: ['*'],
      });
    };
    const canEdit = computed(() => state.resume.editable !== 0);
    const activityId = computed(() => store.state.currentBatch?.activityId);
    return {
      router: useRouter(),
      ...toRefs(state),
      stepCallback,
      printFunc,
      deliverFunc,
      canEdit,
      isSpecific,
      steps,
      title,
      activityId,
    };
  },
};
</script>

<style scoped lang="scss">
.header {
  border-bottom: 2px solid rgba(112, 112, 112, 0.1);
  padding: 10px 10px 6px 10px;
  font-size: 16px;
  .name {
    height: 40px;
    line-height: 40px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  p {
    flex: 1;
    padding: 0 50px;
    color: #ed4013;
    text-align: right;
  }
  h3 {
    flex: 1;
    padding: 0 30px;
    white-space: nowrap;
  }
}
.resume {
  padding: 10px 40px 10px 10px;
  font-size: 16px;
  .content {
    display: flex;
    align-items: flex-start;

    .steps {
      width: 185px;
      padding: 20px;
      color: #c0c4cc;
      font-size: 15px;
      .steps_item {
        &.active {
          color: #67c23a;
          .line {
            background: #67c23a;
          }
        }
        svg {
          width: 24px;
          vertical-align: middle;
          margin-right: 8px;
        }
        .num {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 24px;
          height: 24px;
          border: 2px solid #c0c4cc;
          border-radius: 50%;
          margin-right: 8px;
          font-size: 14px;
          font-weight: 700;
        }
        .line {
          width: 2px;
          height: 80px;
          background: #c0c4cc;
          margin-left: 10px;
        }
      }
    }

    .form_content {
      flex: 1;
      height: 100%;
      &.print {
        background-image: url('../../assets/shuiyin.png');
        background-size: 40%;
        background-position: 40% 0;
        background-repeat: no-repeat repeat;
      }
    }
  }
}
</style>
